import { API, graphqlOperation } from "aws-amplify";

import { listMatchNotesQuery } from "./graphql/queries";

const listMatchNotes = (args) =>
  API.graphql(graphqlOperation(listMatchNotesQuery, args));

export default listMatchNotes;
